import { PlayCircleOutlined, StarOutlined } from '@ant-design/icons';
import { ThemeProvider } from '@mui/material';
import { Button, Col, DatePicker, Divider, Form, Radio, Row, Select } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import * as Api from 'api';
import React, { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
import outerTheme from 'theme/mui';
import classes from './style.module.scss';

const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

const FilterTrash = (props) => {
  const [trachCounter, setTrashCounter] = useState(0);
  const [form] = Form.useForm();
  const [formEdit] = Form.useForm();
  const { auth: { profile } } = useAuth();
  const [loading, setLoading] = useState(false);
  const { md } = useBreakpoint();
  const [cameraArr, setCameraArr] = useState<any[]>([]);
  const [cameraGroups, setCameraGroups] = useState<any[]>([]);
  const [tagArr, setTagArr] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [categories, setCategories] = useState([]);
  const [filterOptions, setFilterOption] = useState({
    category: 'All',
    camera_id: '0',
    fromDate: '',
    toDate: '',
    tag: 'All',
    xl_only: false,
    video_only: false,
    favorite_only: false,
    antlered: 0,
    order_by: 'id',
    length: 20,
  });

  useEffect(() => {
    Api.CAMERAS_GROUPS_TAGS().then(((res: any) => {
      const data = JSON.parse(res.text);
      setCameraArr(data.cameras);
      setCameraGroups(data.cameraGroups);
      setTagArr(data.tags);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
    http_load_categories();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (trachCounter > 0) {
        setTrashCounter(trachCounter - 1);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [trachCounter]);

  useEffect(() => {
    const newFilter = { ...filterOptions, category: props.category };
    form.setFieldsValue({ category: props.category });
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  }, [props.category]);

  useEffect(() => {
    form.setFieldsValue({ length: props.length });
  }, [props.length]);

  useEffect(() => {
    setSelectAll(false);
  }, [filterOptions, props.page]);

  const http_load_categories = () => {
    Api.DETECTION_THRESHOLD().then(((res: any) => {
      const data = JSON.parse(res.text);
      const tcategories = data.filter((item) => item.enable == '1');
      const cates = tcategories.map((item) => item.category);
      setCategories(cates);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onValuesChange = (values, allvalues) => {
    const newFilter = { ...filterOptions, ...allvalues };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onSelectTag = (value) => {
    const newFilter = { ...filterOptions, tag: value };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onChangeDate = (date: any, dateString: string[]) => {
    const newFilter = { ...filterOptions, fromDate: dateString[0], toDate: dateString[1] };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onSelectAll = (e) => {
    props.onSelectAll(e);
  };

  const onClickSelectAll = () => {
    const selectedState = !selectAll;
    setSelectAll(selectedState);
    props.onSelectAll(selectedState);
  };

  const changeDeerSubCategroy = (e) => {
    const val = e.target.value;
    const newFilter = { ...filterOptions, antlered: val };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onChangeXlOnly = (e) => {
    const newFilter = { ...filterOptions, xl_only: !filterOptions.xl_only, video_only: false };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onChangeVideoOnly = (e) => {
    const newFilter = { ...filterOptions, video_only: !filterOptions.video_only, xl_only: false };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onChangeFavoriteOnly = (e) => {
    const newFilter = { ...filterOptions, favorite_only: !filterOptions.favorite_only };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onRestore = () => {
    props.onRestore();
  };

  const onClear = () => {
    props.onClear();
  };

  return (
    <div className={classes.wrapper}>
      <ThemeProvider theme={outerTheme}>
        <Form form={form} style={{ marginTop: md ? 20 : 0 }} onValuesChange={onValuesChange}>
          <Form.Item label="Sort" name="order_by" style={{ marginBottom: 8 }} className={classes.formInputWrapper} initialValue="id">
            <Select dropdownStyle={{ position: 'fixed' }}>
              <Option key="id" value="id">Quick Sort</Option>
              <Option key="time" value="time">Taken Time</Option>
            </Select>
          </Form.Item>
          <Button type={selectAll ? 'default' : 'primary'} onClick={onClickSelectAll} style={{ marginTop: 8, width: '100%' }}>
            {selectAll ? 'Deselect All' : 'Select All'}
          </Button>
          <Divider style={{ marginBottom: 8 }}>Filter</Divider>
          <Button type={filterOptions.xl_only ? 'primary' : 'default'} className={classes.editTrash} onClick={onChangeXlOnly} icon={<img src="/icons/size-xl.png" alt="" className={classes.xl_img} />}>
            XL Images Only
          </Button>
          <Button type={filterOptions.video_only ? 'primary' : 'default'} className={classes.editTrash} onClick={onChangeVideoOnly} icon={<PlayCircleOutlined />}>
            Videos Only
          </Button>
          <Button type={filterOptions.favorite_only ? 'primary' : 'default'} className={classes.editTrash} onClick={onChangeFavoriteOnly} icon={<StarOutlined />}>
            Favorites Only
          </Button>
          {(filterOptions.category == 'deer' || filterOptions.category == 'Deer') && (
            <Radio.Group value={filterOptions.antlered} className={classes.categoryGroup} onChange={changeDeerSubCategroy}>
              <Row>
                <Col span={12}><Radio.Button className={classes.categoryBtn} value="0">All Deer</Radio.Button></Col>
                <Col span={12}><Radio.Button className={classes.categoryBtn} value="1">Bucks Only</Radio.Button></Col>
              </Row>
            </Radio.Group>
          )}
          <Form.Item name="camera_id" className={classes.formInputWrapper} initialValue="0">
            <Select dropdownStyle={{ position: 'fixed' }}>
              <Option key={0} value="0">All Cameras</Option>
              <OptGroup label="Cameras">
                {cameraArr.map((val: any) => (
                  <Option key={val.id} value={val.id}>{val.name}</Option>
                ))}
              </OptGroup>
              <OptGroup label="Camera Groups">
                {cameraGroups.map((val: any) => (
                  <Option key={val.id} value={`group${val.id}`}>{val.name}</Option>
                ))}
              </OptGroup>
            </Select>
          </Form.Item>
          <Form.Item name="category" className={classes.formInputWrapper} initialValue="All">
            <Select dropdownStyle={{ position: 'fixed' }}>
              <Option key="category0" value="All">All Categories</Option>
              {categories.map((val, i) => (
                <Option key={`category${i + 1}`} value={val}>{val}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="tag" className={classes.formInputWrapper} initialValue="">
            <Select dropdownStyle={{ position: 'fixed' }}>
              <Option key={0} value="">All Tags</Option> :
              {tagArr.map((val: any) => (
                val.tag != '' && (<Option key={val.tag} value={val.tag}>{val.tag}</Option>)
              ))}
            </Select>
          </Form.Item>
          <Form.Item className={classes.formInputWrapper}>
            <div>
              <RangePicker style={{ width: '100%' }} onChange={onChangeDate} />
            </div>
          </Form.Item>
        </Form>
        <Divider style={{ marginBottom: 8 }}>Edit</Divider>
        <Form form={formEdit}>
          <Button type="primary" onClick={onRestore} className={classes.editTrash}>
            Restore
          </Button>
          <Button type="primary" onClick={onClear} className={classes.editTrash}>
            Clear
          </Button>
        </Form>
      </ThemeProvider>
    </div>
  );
};

export default FilterTrash;
